export default "__VITE_PUBLIC_ASSET__e90fb4a8__"